// 063-breaking-views — Analytics events for the Breaking Views widget on the
// markets feed page.

import type { EventDefinition } from './navigation';

// ---------------------------------------------------------------------------
// Property types
// ---------------------------------------------------------------------------

export type BreakingViewTappedProperties = {
  marketPubkey: string;
  signature: string;
  /** 1-based rank position of the row at the moment of tap (matches the visible rank label). */
  position: 1 | 2 | 3 | 4 | 5;
};

// ---------------------------------------------------------------------------
// Event definitions
// ---------------------------------------------------------------------------

export const BREAKING_VIEW_TAPPED: EventDefinition<BreakingViewTappedProperties> = {
  name: 'breaking_view_tapped',
};
